import { css } from 'styled-components';
import { getFormattedSpaceValue } from './space';
export const margin = css `
  ${({ m, mt, mb, ml, mr, mx, my }) => `
		${m ? `margin:${getFormattedSpaceValue(m)};` : ''}
		${mt ? `margin-top:${getFormattedSpaceValue(mt)};` : ''}
		${mb ? `margin-bottom:${getFormattedSpaceValue(mb)};` : ''}
		${ml ? `margin-left:${getFormattedSpaceValue(ml)};` : ''}
		${mr ? `margin-right:${getFormattedSpaceValue(mr)};` : ''}
    
		${mx
    ? `
			margin-right:${getFormattedSpaceValue(mx)};
			margin-left:${getFormattedSpaceValue(mx)} ;
		`
    : ''}
		${my
    ? `
			margin-top:${getFormattedSpaceValue(my)};
			margin-bottom:${getFormattedSpaceValue(my)} ;
		`
    : ''}
	`}
`;
